export { default, type SearchParamsInterface } from "./useSearchParamsUpdate";
